import React from "react";
import { motion } from "framer-motion";

const reduceMotion =
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const OFFSET = { up: { y: 28 }, down: { y: -28 }, left: { x: 32 }, right: { x: -32 } };

export default function Reveal({
  children,
  delay = 0,
  from = "up",
  className = "",
  as = "div",
}) {
  const MotionTag = motion[as] || motion.div;
  const offset = OFFSET[from] || OFFSET.up;

  if (reduceMotion) {
    const Tag = as;
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}

export function SectionTitle({ eyebrow, title, subtitle }) {
  return (
    <Reveal className="section-head">
      {eyebrow && <span className="section-eyebrow">{eyebrow}</span>}
      <h2 className="section-title">{title}</h2>
      {subtitle && <p className="section-subtitle">{subtitle}</p>}
    </Reveal>
  );
}
